export default "/profile/images/SendPulse.svg?9240e4fefd8f334542b9b1581b42fbd9";